import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AnalyticService, CommonService } from '@app/core';
import { AppProfileData } from '@app/models';
import { SuveryDetailTable } from '@app/models/survey.model';
import { BroadcastService } from '@app/pages/broadcast/services/broadcast.service';
import { AnalyticLogLabels } from '@app/shared/data/messages';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-key-value-response-table',
    templateUrl: './key-value-response-table.component.html',
    styleUrls: ['./key-value-response-table.component.scss'],
    standalone: false
})
export class KeyValueResponseTableComponent implements OnInit, OnDestroy {
    @Input() tableData!: SuveryDetailTable;
    @Input() pageName?: string;
    private readonly unsubscribeAll$ = new Subject();
    appProfileData!: AppProfileData;

    constructor(
        private readonly _commonService: CommonService,
        private readonly _analyticService: AnalyticService,
        private readonly _broadcastService: BroadcastService
    ) {}

    ngOnInit(): void {
        this._commonService.appProfileDataAsObservable.pipe(takeUntil(this.unsubscribeAll$)).subscribe(appData => {
            this.appProfileData = appData;
        });
    }

    ngOnDestroy() {
        this.unsubscribeAll$.next(null);
        this.unsubscribeAll$.complete();
    }

    onDownload(fileName: string, fileType: string, fileSize?: number, attachmentUrl?: string) {
        if (attachmentUrl) {
            this._broadcastService.downloadBroadcastAttachment({ attachmentUrl }).subscribe((blob: Blob) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                link.click();
                window.URL.revokeObjectURL(url);
            });
        }
        this._analyticService.logAnalyticEvent(AnalyticLogLabels.BroadcastAttachmentDownloaded, {
            timestamp: moment.utc().format(),
            pageName: this.pageName || '',
            fileName: fileName,
            fileSize: fileSize || 0,
            fileType: fileType,
            source_component: 'response_table'
        });
    }
}
